class CollectionDescription extends HTMLElement {
  connectedCallback() {
    this.toggleButtons.forEach((item) => {
      item.addEventListener('click', this.toggleVisibility.bind(this))
    })
  }

  toggleVisibility() {
    this.isActive ? this.close() : this.open()
  }

  open() {
    this.setAttribute('aria-expanded', 'true')
    this.truncatedDescription.setAttribute('aria-hidden', 'true')
    this.fullDescription.setAttribute('aria-hidden', 'false')
  }

  close() {
    this.setAttribute('aria-expanded', 'false')
    this.truncatedDescription.setAttribute('aria-hidden', 'false')
    this.fullDescription.setAttribute('aria-hidden', 'true')
  }

  get isActive() {
    return this.getAttribute('aria-expanded') === 'true'
  }

  get toggleButtons() {
    return this.querySelectorAll('[data-collection-description-el="toggle"]')
  }

  get fullDescription() {
    return this.querySelector('[data-collection-description-el="full"]')
  }

  get truncatedDescription() {
    return this.querySelector('[data-collection-description-el="truncated"]')
  }
}

customElements.define('collection-description', CollectionDescription)